import ApiClient from './alms-api';
import Translator from '../core/i18n';
import { Log } from 'ng2-logger';

const T = Translator.create();
const token: any = localStorage.getItem('access_token');
let _apiClient: ApiClient;
const _logger = Log.create('Files-Service - main.tsx');
export class FileService {

    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestFileDeleteAsync(params: any) {
        return _apiClient.RequestAsync('DELETE', 'api/file/fileUploadId', params.data, token).then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetFileAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/file/getfile', params, token).then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestGetMyFilesAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/file/myfiles', params, token).then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }

    public async RequestAddMyFilesAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/file/addmyfiles', params, token).then((responseData: Response) => {
            return responseData;
        }).catch((responseData) => {
            return responseData;
        });
    }
}

